import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initAnalytics } from "./lib/analytics";
import { capturePrefilledSite } from "./lib/onboarding/site-prefill";
import "./index.css";

// Initialize analytics before rendering
initAnalytics();

// The site scanner's call to action arrives as `/signup?site=<host>` (task
// 293). Captured here, before React renders, rather than in the signup
// page's effect: that page is a lazy chunk, and a visitor who moves on
// before it mounts would lose the host.
if (window.location.pathname.replace(/\/$/, "") === "/signup") {
  capturePrefilledSite(window.location.search);
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
